import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface ExternalLinkIconProps {
  size?: number
  color?: string
}

const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size + 1} // Adding 1 to maintain original aspect ratio of 16:17
      viewBox='0 0 16 17'
      fill='none'
    >
      <path
        d='M12.6667 13.1667H3.33333V3.83333H8V2.5H3.33333C2.59333 2.5 2 3.1 2 3.83333V13.1667C2 13.9 2.59333 14.5 3.33333 14.5H12.6667C13.4 14.5 14 13.9 14 13.1667V8.5H12.6667V13.1667ZM9.33333 2.5V3.83333H11.7267L5.17333 10.3867L6.11333 11.3267L12.6667 4.77333V7.16667H14V2.5H9.33333Z'
        fill={color}
      />
    </svg>
  )
}

export default ExternalLinkIcon
